import { ReplaySubject } from 'rxjs';
import { ViewSessionEvent } from './view-session-event.model';
import { Mediaclip } from './../../../../interfaces/mediaclip';
import { SapiService } from '../../../../services/sapi.service';

export class ViewSession {
	public sid: string; // clip-session ID
	public uid: string; // view-session ID
	public vu: string; // user ID
	public currentMediaclip: Mediaclip;
	public duration: number;
	public viewHistory: Mediaclip[];
	public oldRanges: any[]; // tmp
	public ranges: any[];
	public interactions: any[];
	public viewTime: number;
	public startTime: Date;
	public playState: string;
	public publication: string;
	public activeAdPosition: any;

	private events: ViewSessionEvent[];
	private activeRange: any;

	private prevEv: ViewSessionEvent;
	private hadStartEvent: boolean;
	private isFinished: boolean;
	private _eventAdded: ReplaySubject<ViewSessionEvent>;
	// private _prevSN: number;
	private _referrer: string;
	private _domain: string;
	private _phase: string;
	private _adInfo: any;

	constructor(protected sapiService: SapiService) {
		this.hadStartEvent = false;
		this.isFinished = false;
		this.events = [];
		this.ranges = [];
		this.interactions = [];
		this.viewTime = 0;
		this.playState = 'init';
		this._phase = 'INIT';
		this.currentMediaclip = {};
		this._adInfo = {};
		this.activeAdPosition = {};
		this._eventAdded = new ReplaySubject();
	}

	// get activeAdPosition() {
	// 	// console.warn('GET this._activeAdPosition', this._activeAdPosition)
	// 	return this._activeAdPosition;
	// }

	get adInfo() {
		return this._adInfo;
	}

	get phase() {
		return this._phase;
	}

	get referrer() {
		return this._referrer;
	}

	get domain() {
		return this._domain;
	}

	get eventAdded() {
		return this._eventAdded.asObservable();
	}

	public addEvent(ev: ViewSessionEvent) {
		// console.warn('addEvent ViewSessionEvent prev: ' + this._prevSN, '; current: ' + ev.sn, ev);
		this._extractInfo(ev);
		// get full mediaclip data. Might not be needed if we get all info from the events.
		// if (!this.currentMediaclip && ev.id) {
		// 	this.sapiService.get('mediaclip', ev.id).subscribe( (mc) => {
		// 		console.warn('mc', mc);
		// 		this.currentMediaclip = mc;
		// 		this.duration = Number(mc['length']);
		// 	});
		// }
		this.events.push(ev);
		this.determinePhase(ev);
		this.determinePlayState(ev);
		this.calcRange(ev);
		this.calcViewTime();
		this.prevEv = ev;
		this._eventAdded.next(ev);
	}

	calcViewTime() {
		this.viewTime = 0;
		if (this.ranges && this.ranges.length) {
			this.ranges.forEach((range) => {
				if (range.total) {
					this.viewTime += range.total;
				}
			});
		}
	}

	determinePhase(ev: ViewSessionEvent) {
		switch (ev.ev) {
			default:
				switch (ev.ap) {
					default:
						// this._phase = 'MAIN';
						break;

					case 'preroll':
						this._phase = 'PRE';
						this._adInfo.prerollPlayed = true;
						break;

					case 'postroll':
						this._phase = 'POST';
						this._adInfo.postrollPlayed = true;
						break;
				}
				break;
			case 'st':
				this.activeAdPosition = {};
				this._phase = 'MAIN';
				break;

			case 'xfn':
				if (ev.et === 'View') {
					this.activeAdPosition = {};
					this._phase = 'EXIT';
				}
				break;
		}
		// console.warn('determinePhase ', ev, this._phase);
	}

	determinePlayState(ev: ViewSessionEvent) {
		if (ev.fromBacklog === true && ev.playState) {
			this.playState = ev.playState;
			return;
		}
		if (this.playState !== 'finished') {
			switch (ev.ev) {
				default:
					break;
				case 'it':
					this.playState = 'init';
					break;
				case 'st':
				case 'rs':
					this.playState = 'playing';
					break;
				case 'pa':
					this.playState = 'paused';
					break;
				case 'fn':
					this.playState = 'finished';
					break;
			}
		} else if (ev.ev === 'st') {
			this.playState = 'playing';
		}
	}

	updateActiveRange(to: number, ev: ViewSessionEvent) {
		if (this.uid === '8D261084-8DFC-4BC4-BD47-916C4124FCB4') {
			// console.warn('updateActiveRange to ', to, ev);
		}
		if (this.activeRange && this.activeRange.from < to) {
			this.activeRange.to = to;
			this.activeRange.total = this.activeRange.to - this.activeRange.from;
			if (ev.ev !== 'pg') {
				this.activeRange.events.push(ev);
			}
		}
	}

	addRange(range: any, ev: ViewSessionEvent) {
		if (!range.to) {
			range.to = range.from + 0.1;
		}
		range.total = range.to - range.from;

		if (this.activeRange && (this.activeRange.total < 0.75 || !this.activeRange.total)) { // ignore small ranges and faulty ranges
			const i = this.ranges.indexOf(this.activeRange);
			this.ranges.splice(i, 1);
		}

		if (this.activeRange) {
			this.activeRange.isActive = false;
		}

		this.activeRange = range;
		this.activeRange.isActive = true;
		this.activeRange.events = [ev];
		this.ranges.push(range);
		// if (this.uid === '8D261084-8DFC-4BC4-BD47-916C4124FCB4') {
		// 	console.warn('addRange range / this.ranges ', range, this.ranges);
		// }
	}

	calcRange(ev: ViewSessionEvent) {
		if (ev.fromBacklog === true) {
			this.hadStartEvent = true;
			return this.addRange({ from: 0, to: ev.to }, ev);
		}
		if (ev.ev !== 'st' && !this.hadStartEvent && !this.isFinished) {
			return false;
		} else if (ev.ev === 'fn') {
			// last event
			this.updateActiveRange(ev.to, ev);
			return false;
		}
		switch (ev.ev) {
			default:
				this.updateActiveRange(ev.to, ev);
				break;
			case 'st':
				this.addRange({ from: 0 }, ev);
				break;
			case 'se':
				if (this.playState === 'paused') {
					this.updateActiveRange(this.prevEv.to, ev);
				} else {
					const delta = ev.timestamp / 1000 - this.prevEv.timestamp / 1000;
					if (this.activeRange) {
						const end = delta + this.activeRange.to;
						this.updateActiveRange(end, ev);
					}
				}

				if (ev.to) {
					// seek forward or backward, the to is the start of a new range:
					this.addRange({ from: ev.to }, ev);
				}
				break;
		}
	}

	public calculateRanges() {
		if (this.currentMediaclip && this.currentMediaclip.length && this.events && this.events.length) {
			// this.oldRanges = this._calculateRanges(this.events, Number(this.currentMediaclip['length']));
			// console.warn('calculateRanges this.ranges', this.ranges);
		}
	}

	private extractHostname(url: string) {
		let hostname;

		// find & remove protocol (http, ftp, etc.) and get hostname
		if (url.indexOf('://') > -1) {
			hostname = url.split('/')[2];
		} else {
			hostname = url.split('/')[0];
		}

		// find & remove port number
		hostname = hostname.split(':')[0];
		// find & remove "?"
		hostname = hostname.split('?')[0];
		return hostname;
	}

	private _extractInfo(ev: ViewSessionEvent) {

		if (ev.clip) {
			this.currentMediaclip = { ...this.currentMediaclip, ...ev.clip };
		}
		if (ev.ct) {
			this.currentMediaclip.title = ev.ct;
		}
		if (ev.sot) {
			this.currentMediaclip.sourcetype = ev.sot;
		}
		if (ev.xu) {
			this._referrer = ev.xu;
			this._domain = this.extractHostname(ev.xu);
		}

		if (!this.sid) {
			this.sid = ev.sid;
		}
		if (!this.uid && ev.uid) {
			this.uid = ev.uid;
		}
		if (ev.vu) {
			this.vu = ev.vu;
		}
		if (ev.ev === 'st') {
			this.hadStartEvent = true;
		}
		if (ev.to) {
			ev.to = Number(ev.to) / 1000;
		}
		if (ev.ev === 'fn') {
			this.isFinished = true;
		}
		if (ev.ev === 'xcl' && ev.et === 'Widget') {
			this.interactions.push(ev);
		}
		if (ev.time) {
			ev.timestamp = (new Date(ev.time)).getTime();
			const eventTime = ev.time;
			if (!this.startTime || this.startTime > eventTime) {
				this.startTime = eventTime;
				// console.warn('this.sid / ev.time / this.startTime', this.sid, ev.time, this.startTime);
			}
		}
		if (ev.pp) {
			this.publication = ev.pp;
		}
		// set Duration if not set (live clips / some pubs) to highest to:
		if (!this.duration && ev.to > this.duration) {
			this.duration = ev.to;
		}

		if (ev.et === 'Creative' && ev.ap) {
			if (!this._adInfo[ev.ap]) {
				this._adInfo[ev.ap] = {};
			}
			if (ev.ev === 'xld') {
				this._adInfo[ev.ap].vast_url = ev.ar;
				this._adInfo[ev.ap].position = ev.ap;
				this._adInfo[ev.ap].ad_id = ev.adi;
				this._adInfo[ev.ap].ad_title = ev.adt;
				this._adInfo[ev.ap].ad_system = ev.ads;
				this._adInfo[ev.ap].ad_duration = Number(ev.add);
				this._adInfo[ev.ap].adunit = ev.auc;
				this._adInfo[ev.ap].lineitem = ev.lic;
				this.currentMediaclip.id = this._adInfo[ev.ap].cid = ev.cid;

			} else if (ev.ev === 'xst') {
				this._adInfo[ev.ap].played = true;
				this.activeAdPosition = this._adInfo[ev.ap];
			}
			if (this._adInfo[ev.ap].ad_duration) {
				this.duration = this._adInfo[ev.ap].ad_duration;
			}
		} else if (ev.id && Number(ev.id) && !ev.et) {
			this.currentMediaclip.id = ev.id;
			// this._activeAdPosition = {};
			if (ev.du) {
				this.duration = this.currentMediaclip.length = Number(ev.du) / 1000;
			}
		}
		if (ev.viewedCommercials && ev.viewedCommercials.length) {
			ev.viewedCommercials.forEach((cm: any) => {
				this._adInfo[cm.ap] = { position: cm.ap, played: true };
			});
		}
	}
}
